import { FC, useState } from 'react';

import { Tabs } from '@components/base';
import { ProviderIcon } from '@components/content';
import { useProviderNames } from '@hooks/useProviderNames';
import { vodProviderIdentifier } from '@models/Provider';
import { DetailedPlaybackOption } from '@models/Title';

import RawMetadataRevisions from './components/RawMetadataRevisions';
import RawDataRevisionProvider from './hooks/useRawDataRevision/provider';

type RawDataRevisionsTabContentProps = {
  playbackOptions: DetailedPlaybackOption[];
};

const RawMetadataTabContent: FC<RawDataRevisionsTabContentProps> = ({ playbackOptions }) => {
  const { getProviderName } = useProviderNames();

  const [tab, setTab] = useState(playbackOptions[0]?.id);

  return playbackOptions.length === 1 ? (
    <RawDataRevisionProvider
      key={playbackOptions[0].id}
      playbackOptionId={playbackOptions[0].id}
      sourceId={playbackOptions[0].sourceId}
    >
      <RawMetadataRevisions playbackOption={playbackOptions[0]} />
    </RawDataRevisionProvider>
  ) : (
    <Tabs
      buttonVariant='toggleButton'
      onTabChange={newTab => setTab(newTab)}
      selectedTab={tab}
      tabs={playbackOptions.map(playbackOption => {
        const { id, providerIdentifier, sourceId } = playbackOption;

        const title =
          providerIdentifier === vodProviderIdentifier
            ? `${getProviderName(providerIdentifier)} (${sourceId})`
            : undefined;

        return {
          'aria-label': getProviderName(providerIdentifier),
          BoxProps: { p: 0 },
          content: (
            <RawDataRevisionProvider key={id} playbackOptionId={id} sourceId={sourceId}>
              <RawMetadataRevisions playbackOption={playbackOption} />
            </RawDataRevisionProvider>
          ),
          title: (
            <ProviderIcon
              providerIdentifier={providerIdentifier}
              size='large'
              title={title}
              variant='rounded'
            />
          ),
          value: playbackOption.id,
        };
      })}
      wrapperProps={{ width: undefined }}
    />
  );
};

export default RawMetadataTabContent;
